module.exports = __webpack_public_path__ + "static/media/coy.e42bb391.png";